import { ApiBase } from './ApiBase';
class OfferListingApiClientModel extends ApiBase {
    constructor() {
        super(...arguments);
        this.getOffersListing = (params) => {
            return this.get('/offer-listing', Object.assign({ 
                // NOTE: By default API returns only 'LIVE' products.
                status: ['PUBLIC', 'HIDDEN'] }, params));
        };
    }
}
export const OfferListingApiClient = new OfferListingApiClientModel();
